import { render } from "./ChangeEmailModal.vue?vue&type=template&id=653f6c50&scoped=true"
import script from "./ChangeEmailModal.vue?vue&type=script&lang=js"
export * from "./ChangeEmailModal.vue?vue&type=script&lang=js"

import "./ChangeEmailModal.vue?vue&type=style&index=0&id=653f6c50&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-653f6c50"

export default script